import { useContext } from 'react';
import ToastContext from './AlertToastContext';

export default function useToast() {
  return useContext(ToastContext);
}
